import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=05bb1a10&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=js&"
export * from "./Timer.vue?vue&type=script&lang=js&"
import style0 from "./Timer.vue?vue&type=style&index=0&id=05bb1a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb1a10",
  null
  
)

export default component.exports